import styled from 'styled-components';

export const CreditsSection = styled.div`
  width: 100%;
  
  color: ${({ theme }) => theme.black};
`;

export const CreditsHeading = styled.h2`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 22px;
  line-height: 28px;
  
  @media(min-width: 768px) {
    margin-bottom: 10px;
  
    font-size: 24px;
    line-height: 30px;
  }
`;

export const YourCreditsList = styled.ul`
  li {
    position: relative;
    
    display: flex;
    flex-direction: column;
    padding: 20px 0;
    
    &:not(:last-child) {
      border-bottom: 1px solid #ebebeb;
    }
    
    @media(min-width: 1024px) {
      align-items: center;
      flex-direction: row;
    }
  }
`;

export const CreditsPrice = styled.span`
  position: absolute;
  right: 0;
  
  font-weight: 700;
  font-size: 17px;
  color: ${({ priceColo }) => priceColo};
  
  @media(min-width: 1024px) {
    font-size: 20px;
  }
`;

export const CreditsDate = styled.span`
  margin-bottom: 10px;
  
  font-size: 10px;
  line-height: 1;
  
  @media(min-width: 1024px) {
    position: absolute;
    top: 5px;
    
    font-size: 12px;
  }
`;

export const CreditsType = styled.h3`
  margin: 0;
  padding: 0;
  
  font-size: 16px;
  line-height: 1;
  
  @media(min-width: 1024px) {
    margin-right: 20px;    
    font-size: 20px;
  }
`;

export const CreditsDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 12px;
  line-height: 18px;
  
  @media(min-width: 1024px) {
    width: 60%;
    
    font-size: 16px;
  }
`;
